var o = new Map(),
  e = new Map(),
  n = new Map(),
  c = new Map(),
  i = new Map(),
  p = function p(s, t) {
    return s.startsWith("flag-") ? n.set(s, t) : s.startsWith("payment-") ? i.set(s, t) : s.endsWith("-logo") ? c.set(s, t) : e.set(s, t), o.set(s, t), t;
  };
export { e as base, n as flags, p as icon, o as icons, c as logos, i as payments };